import React from 'react';
import { isMobile } from 'react-device-detect';
import { Typography, Badge } from '@one-thd/sui-atomic-components';
import ItemImage from '../return-summary/ItemImage';
var PostSelectionItems = function (_a) {
    var selectedReturnItems = _a.selectedReturnItems;
    var itemCountMax = isMobile ? 4 : 6;
    var getAdditionalItemCount = function () {
        var additionalItemsCount = selectedReturnItems.length - (itemCountMax - 1);
        var output = additionalItemsCount > 0 ? additionalItemsCount : 0;
        return "+".concat(output);
    };
    // Maps return quantity digit length to correct center badge position
    var BADGE_LEFT_POSITIONS = {
        1: 'sui-left-9',
        2: 'sui-left-[3.3rem]',
    };
    return (React.createElement("div", { className: "sui-flex sui-gap-4" }, selectedReturnItems.map(function (item, index) {
        if (index > itemCountMax - 1)
            return null;
        if (index === itemCountMax - 1 &&
            selectedReturnItems.length > itemCountMax) {
            return (React.createElement("div", { className: "sui-grid sui-bg-strong sui-rounded-base sui-place-items-center sui-z-10 overflow-items-indicator", key: item === null || item === void 0 ? void 0 : item.lineItemId },
                React.createElement(Typography, { height: "tight", variant: "body-base" }, getAdditionalItemCount())));
        }
        var badgeLeftPosition = BADGE_LEFT_POSITIONS[item.returnQuantity.toString().length] ||
            'sui-left-9';
        return (React.createElement("div", { key: item === null || item === void 0 ? void 0 : item.lineItemId, className: "sui-relative" },
            React.createElement(ItemImage, { itemDescription: item === null || item === void 0 ? void 0 : item.itemDescription, imageUrl: item === null || item === void 0 ? void 0 : item.imageUrl }),
            item.returnQuantity > 1 && (React.createElement("div", { className: "sui-mr-4 sui-z-10 sui-absolute sui-bottom-9 ".concat(badgeLeftPosition), "data-testid": "items-to-return-quantity-".concat(item.returnQuantity) },
                React.createElement(Badge, { size: "small" }, item.returnQuantity)))));
    })));
};
export default PostSelectionItems;
